import { Navigate, createBrowserRouter } from 'react-router';

import { AppLayout } from './components/AppLayout';
import { AuditPage } from './pages/AuditPage';
import { PeoplePage } from './pages/PeoplePage';
import { ProjectsPage } from './pages/ProjectsPage';
import { SettingsPage } from './pages/SettingsPage';
import { StreamsPage } from './pages/StreamsPage';
import { SystemsPage } from './pages/SystemsPage';
import { TeamsPage } from './pages/TeamsPage';
import { LoggedOutPage } from './pages/LoggedOutPage';

/**
 * The seven registry views (F-09/F-18/F-19/F-19b/F-21/F-22/F-23). `/` has no
 * view of its own — the projects table is the working surface, so it is the
 * default destination. All of them sit inside the shell layout and share the
 * global (URL-synced) filters from `<FiltersProvider>`.
 *
 * `/logged-out` sits OUTSIDE the shell layout on purpose: a signed-out visitor
 * must not see an app frame (it would imply they are still in).
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <Navigate to="/projects" replace /> },
      { path: 'streams', element: <StreamsPage /> },
      { path: 'projects', element: <ProjectsPage /> },
      { path: 'people', element: <PeoplePage /> },
      { path: 'teams', element: <TeamsPage /> },
      { path: 'systems', element: <SystemsPage /> },
      { path: 'audit', element: <AuditPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
  { path: '/logged-out', element: <LoggedOutPage /> },
]);
